import axios from '../../utils/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { apiEndpoint } from '../../utils/apiEndpointUtility';

import {
	processCardInfo,
	processCardInfoCompleted,
	processCardInfoFailed
} from './processCardInfoSlice';

export const processCardInfoEpic = (action$) =>
	action$.pipe(
		ofType(processCardInfo),
		mergeMap(async (action) => {
			try {
				const cardInfo = action.payload;
				const response = await axios.post(
					`${apiEndpoint()}/api/v2/checkout/payment`,
					cardInfo
				);

				if (response.status !== 200 || response.data.message === 'rejected') {
					throw new Error(response.data);
				}
				return response.data;
			} catch (e) {
				throw e;
			}
		}),
		switchMap((response) => [processCardInfoCompleted(response)]),
		catchError((error, source) =>
			merge(of(processCardInfoFailed(error.message)), source)
		)
	);

export default [processCardInfoEpic];
